import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class VacationRequestService {

  url = ConfigService.toApiUrl('vacation-requests/');

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this.url}`, ConfigService.addAction('list'));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.addAction('add'));
  }

  update(id: any, ressource: any) {
    ressource['_method'] = 'patch';
    return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete'));
  }

  decide(id: any, state: any, note: any) {
    return this.http.post<any>(`${ConfigService.toApiUrl('vacation-requests-decide')}/${id}/state/${state}`, { decision_note: note }, ConfigService.addAction('status'));
  }
}
